import { categoryRecipeConstants } from '../_constants';

export function categoriesRecipe(state = {}, action) {
  switch (action.type) {
    case categoryRecipeConstants.GETALL_REQUEST:
      return {
        loading_cr: true
      };
    case categoryRecipeConstants.GETALL_SUCCESS:
      let options=[];

      let sorted_categories = action.categoriesRecipe;
      if (sorted_categories){
        sorted_categories = sorted_categories.sort(function (a, b) {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        })
      }

      sorted_categories.map((item,index)=>
          options[index]= {key:index,text:item.name,value:item.id});
      return {
        loading_cr: false,
        items: sorted_categories,
        options: options
      };
    case categoryRecipeConstants.GETALL_FAILURE:
      return { 
        error: action.error
      };
    case categoryRecipeConstants.GET_REQUEST:
      return {
        ...state,
        loading: true
      };
    case categoryRecipeConstants.GET_SUCCESS:
      return {
        ...state,
        selected: action.recipes
      };
    case categoryRecipeConstants.GET_FAILURE:
      return { 
        error: action.error
      };
    case categoryRecipeConstants.ADD_REQUEST:
      return {
        ...state,
        adding: true
      };
    case categoryRecipeConstants.ADD_SUCCESS:
      let newItems = [...state.items, action.categoriesRecipe];
      newItems  =  newItems.sort(function (a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      })
      let newOptions=[];
      newItems.map((item,index)=>
        newOptions[index]= {key:index,text:item.name,value:item.id});

      return {
          ...state,
          adding: false,
          added: true,
          items: newItems,
          options: newOptions
      };
    case categoryRecipeConstants.ADD_FAILURE:
      return { 
        error: action.error
      };
    case categoryRecipeConstants.DELETE_REQUEST:
      return {
        ...state,
        deleting: true
      };
    case categoryRecipeConstants.DELETE_SUCCESS:
      newItems = state.items.filter(category => category.id != action.id);
      newOptions=[];
        newItems.map((item,index)=>
          newOptions[index]= {key:index,text:item.name,value:item.id});
      return {
        ...state,
        deleting: false,
        deleted: true,
        items: newItems,
        options: newOptions
      };
    case categoryRecipeConstants.DELETE_FAILURE:
      return {
        error: action.error
/*         ...state,
        items: state.items.map(recipe => {
          if (recipe.id === action.id) {
            // make copy of user without 'deleting:true' property
            const { deleting, ...recipeCopy } = recipe;
            // return copy of user with 'deleteError:[error]' property
            return { ...recipeCopy, deleteError: action.error };
          }
          return recipe;
        }) */
      };
    case categoryRecipeConstants.UPDATE_REQUEST:
      return {
        ...state,
        updating: true
      };
    case categoryRecipeConstants.UPDATE_SUCCESS:
      newItems = state.items.map(category =>  {     
            if (category.id === action.id) {
              return action.categoriesRecipe;
            }
            return category;
        });
      newOptions=[];
        newItems.map((item,index)=>
          newOptions[index]= {key:index,text:item.name,value:item.id});
      return {
        ...state,
        updating: false,
        updated: true,
        items: newItems,
        options: newOptions
      };
    case categoryRecipeConstants.UPDATE_FAILURE:
      return {
        error: action.error
      };

    case categoryRecipeConstants.COUNT_REQUEST:
      return {
        counting: true
      };
    case categoryRecipeConstants.COUNT_SUCCESS:
      return {
        counting: false,
        count: action.categoriesRecipe

      };
    case categoryRecipeConstants.COUNT_FAILURE:
      return { 
        error: action.error
      };

    default:
      return state
  }
}